var _g, _circle, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDownloadCircleIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1063_3213)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.9347 28.6891H10.8303V30.5882H28.9347V28.6891Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8383 7.64706H18.9265V24.3022H20.8383V7.64706Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8824 26.1918L11.0405 17.4085L12.3883 16.0601L19.8824 23.5046L27.3766 16.0601L28.7243 17.4085L19.8824 26.1918Z",
    fill: "white"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19.5,
    cy: 19.5,
    r: 18.5,
    stroke: "white",
    strokeWidth: 2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1063_3213"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22.9412,
    height: 22.9412,
    fill: "white",
    transform: "translate(8.41187 7.64706)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadCircleIcon);
export default __webpack_public_path__ + "static/media/DownloadCircleIcon.6991c89e53156eb348088a36e5b08676.svg";
export { ForwardRef as ReactComponent };